export enum sortTypes {
  ascending = 'ASC',
  descending = 'DESC',
}
